const PORTAL_URL = {
    IMMONET: 'https://www.immonet.de',
    IMMOWELT: 'https://www.immowelt.de',
};
const GERMAN_PROFILES_PATH = {
    IMMONET: 'anbieter',
    IMMOWELT: 'profil',
};
const WLAC_URLS = [
    'agency-card-mfe.assured-muskrat-dev.aws.aviv.eu',
    'localhost',
    'agency-card-mfe.assured-muskrat-preview.aws.aviv.eu',
];
export class AgencyProfileUrlGenerator {
    static createProfileLink(id, loggerError, params) {
        try {
            const baseUrl = this.getBaseUrl();
            const profile = this.getProfileType(baseUrl);
            const queryParams = this.formatUrlParams(params);
            return `${baseUrl}/${profile}/id-${id}${queryParams}`;
        }
        catch (error) {
            loggerError(`Failed to create profile link: ${error}`);
            return '';
        }
    }
    static getBaseUrl() {
        const { hostname, origin } = window.location;
        return WLAC_URLS.includes(hostname) ? PORTAL_URL.IMMOWELT : origin;
    }
    static getProfileType(baseUrl) {
        return baseUrl.includes('immonet')
            ? GERMAN_PROFILES_PATH.IMMONET
            : GERMAN_PROFILES_PATH.IMMOWELT;
    }
    static formatUrlParams(params) {
        if (!params || Object.keys(params).length === 0) {
            return '';
        }
        return Object.entries(params)
            .map(([key, value], index) => `${index === 0 ? '?' : '&'}${key}=${value}`)
            .join('');
    }
}
